import React from 'react';

import Tooltip from 'shared/components/atoms/Tooltip/NewTooltip';
import { Flex } from 'shared/components/display';

import ttUploadedIcon from 'shared/images/tiktok/tt-uploaded-icon.svg';

import styles from './styles';

interface Props {
  showTooltip?: boolean;
  showHoverBox?: boolean;
}
const TikTokUploadedIcon: React.FC<Props> = ({ showTooltip = false }) => {
  return (
    <Tooltip content="Uploaded to the TikTok Library" disabled={!showTooltip}>
      <Flex css={styles} className="tt-uploaded-icon">
        <img src={ttUploadedIcon} className="tt-uploaded-icon__icon" />
      </Flex>
    </Tooltip>
  );
};

export default TikTokUploadedIcon;
